import { dateRangeFromSpec } from '../utils/datePresets';
import { querySpecToChartType } from '../utils/chartTypeMapping';

/**
 * Hydrate report builder UI state from a saved report or query spec.
 */
export function querySpecToBuilderState(report = {}) {
  const spec = report.query_spec || report;
  const visualization = report.visualization || spec.visualization || {};
  const chartType = querySpecToChartType({
    ...spec,
    visualization,
  });

  const dimension = spec.dimension || '';
  let includedValues = [];
  let filters = [...(spec.filters || [])];

  if (dimension) {
    const sliceIndex = filters.findIndex(
      (item) => item.field === dimension && item.operator === 'in'
    );
    if (sliceIndex >= 0) {
      const raw = filters[sliceIndex].value;
      includedValues = Array.isArray(raw) ? raw.map(String) : [String(raw)];
      filters = filters.filter((_, index) => index !== sliceIndex);
    }
  }

  return {
    dataset: spec.dataset || '',
    accountId: spec.account_id || '',
    campaignIds: (spec.campaign_ids || []).map(String),
    leadsFormIds: (spec.leads_form_ids || []).map(String),
    chartType,
    metric: spec.metric || 'count',
    aggregation: spec.metric_aggregation || 'count',
    measureField: spec.metric_field || '',
    dimension,
    tableColumns: Array.isArray(spec.columns) && spec.columns.length
      ? spec.columns.map(String)
      : (dimension ? [dimension] : []),
    filters,
    includedValues,
    dateRange: dateRangeFromSpec(spec.date_range),
    templateId: spec.template_id != null ? String(spec.template_id) : '',
    botNumber: spec.bot_number != null ? String(spec.bot_number) : (spec.botNumber != null ? String(spec.botNumber) : ''),
    detailLevel: spec.detail_level || 'standard',
    includeSessions: typeof spec.include_sessions === 'boolean' ? spec.include_sessions : true,
    reportName: report.name || '',
    scopeLocked: false,
    scopeContext: {},
  };
}

export default querySpecToBuilderState;
